import type { ReactNode } from "react";
import { DesignLabErrorBoundary } from "@design-lab/shared/ui";

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <DesignLabErrorBoundary boundary="DesignLabApp" onReset={() => window.location.reload()}>
      {children}
    </DesignLabErrorBoundary>
  );
}
